import { Link } from "@tanstack/react-router";
import { MapPin, Phone, Mail } from "lucide-react";
import { VortioBadge } from "./VortioBadge";
import { BUSINESS_SCHEMA } from "@/lib/seo";

export function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h2 className="font-heading text-2xl mb-3">Malak BnB Resort</h2>
            <p className="text-primary-foreground/70 text-sm leading-relaxed">
              Your Home Away From Home, Just Steps from Crystal Beach and Niagara Falls.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-primary-foreground/50">
              Quick Links
            </h3>
            <nav className="flex flex-col gap-2">
              {[
                { to: "/rooms", label: "Rooms" },
                { to: "/explore", label: "Explore" },
                { to: "/meetings-and-events", label: "Meetings & Events" },
                { to: "/blog", label: "Blog & Guides" },
                { to: "/about", label: "About Us" },
                { to: "/reservation-details", label: "How Booking Works" },
                { to: "/faq", label: "FAQ" },
                { to: "/terms-and-cancellation-policy", label: "Terms & Cancellation Policy" },
                { to: "/contact", label: "Contact" },
                { to: "/book", label: "Request to Book" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-primary-foreground/50">
              Contact Us
            </h3>
            <div className="flex flex-col gap-3 text-sm text-primary-foreground/70">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                <a
                  href={BUSINESS_SCHEMA.hasMap}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-foreground transition-colors"
                >
                  264 Ridge Road South, Crystal Beach, Ontario, Canada
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 shrink-0" />
                <a href="tel:+12899298055" className="hover:text-primary-foreground transition-colors">
                  1-289-929-8055
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 shrink-0" />
                <a href="mailto:infomalakbnb@gmail.com" className="hover:text-primary-foreground transition-colors">
                  infomalakbnb@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-primary-foreground/50">
          <span>© {new Date().getFullYear()} Malak BnB Resort. All rights reserved.</span>
          <VortioBadge />
        </div>
      </div>
    </footer>
  );
}
